import {
  Typography,
  Tooltip,
  Container,
  Stack,
  Grid,
  Box,
  FormControl,
  TextField,
  Divider,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputAdornment,
  Checkbox,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import Alert from "@mui/material/Alert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/es"; // Importa el archivo de localización para español
import { ContextSession } from "../../../services/ContextSession";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CryptoJS from "crypto-js";
import IdentidadEjemplo from "../IdentidadEjemplo.jpg";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import WarningIcon from "@mui/icons-material/Warning";
import PhoneIcon from "@mui/icons-material/Phone";
import requisitos from "../../../components/RequisitosRazonada.jpg";
dayjs.locale("es"); // Establece el idioma local a español

function ConstanciaRazonadaScreen() {
  const isMobile = useMediaQuery("(max-width:820px)"); // Detectar si es una pantalla móvil
  const sessi = React.useContext(ContextSession);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [fechaVacia, setFechaVacia] = React.useState(null);
  const [EstadoParticipante, setEstadoParticipante] = useState("");
  const [edad, setEdad] = useState(null); // Estado para la edad
  const [precioCons, setPrecioCons] = useState(null); // Estado para la edad
  const [loading, setLoading] = useState(false); // Estado para manejar el loading del proceso de descarga
  const [openInstructions, setOpenInstructions] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [solicitudGenerada, setSolicitudGenerada] = useState(false);
  const [numeroSolicitud, setNumeroSolicitud] = useState(null);
  const [montoConstancia, setMontoConstancia] = useState(null);
  const navigate = useNavigate();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedIdentidadSoli, setSelectedIdentidadSoli] = useState(null);
  const [selectedConstancia, setSelectedConstancia] = useState(null);
  const [comentarioSolicitud, setComentarioSolicitud] = useState("");
  const [telefono, setTelefono] = useState("");
  const [open, setOpen] = useState(true);
  const [aceptoPago, setAceptoPago] = useState(false);
  const [aceptoDoc, setAceptoDoc] = useState(false);

  const dominio = "https://be.injupemp.gob.hn:8443";

  const generarNumeroSolicitud = () => {
    // Generar un número de solicitud aleatorio de 8 dígitos
    const numero = Math.floor(10000000 + Math.random() * 90000000);
    return numero.toString();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const useFront =
    "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
  const handleSolicitarConstancia = async () => {
    setLoading(true);

    try {
      // Generar la firma digital
      const queryString = `identidad=${sessi.sessionData.identidad}`;
      const signature = CryptoJS.HmacSHA256(queryString, useFront).toString(
        CryptoJS.enc.Hex
      );

      // Construir el formData
      const formData = new FormData();
      formData.append("identidad", sessi.sessionData.identidad);
      formData.append("IdConstancia", 2);
      formData.append("DetalleSolicitud", comentarioSolicitud || "");
      formData.append("CopiaDNI", selectedIdentidadSoli);
      formData.append("CopiaConstancias", selectedConstancia);
      formData.append("Telefono", telefono);

      // Realizar la petición POST
      const response = await fetch(
        `${dominio}/api/ConstanciaPag/CrearConstancia/`,
        {
          // const response = await fetch(
          //   "http://172.20.7.10:8082/api/ConstanciaPag/CrearConstancia/",
          //   {
          method: "POST",
          headers: {
            // No se coloca Content-Type aquí para que el browser lo ponga automáticamente
            "X-Signature": signature,
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Error al procesar la solicitud");
      }

      setNumeroSolicitud(data.NumeroSolicitud);
      setMontoConstancia(data?.constancia?.monto ?? null);
      setSolicitudGenerada(true);
      setOpenInstructions(true);
    } catch (error) {
      console.error("Error al solicitar constancia:", error);
      setErrorMessage(
        error.message || "Ocurrió un error al procesar su solicitud"
      );
      setOpenErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseInstructions = () => {
    setOpenInstructions(false);
    navigate("/Mis Solicitudes/MisSolicitudes");
  };

  useEffect(() => {
    const calcularEdad = () => {
      const fechaNacimiento = new Date(selectedDate);
      const hoy = new Date();
      let edadCalculada = hoy.getFullYear() - fechaNacimiento.getFullYear();
      const mes = hoy.getMonth() - fechaNacimiento.getMonth();
      if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
        edadCalculada--;
      }
      setEdad(edadCalculada);
      setPrecioCons(edadCalculada >= 60 ? 0 : 200); // Lógica para establecer el precio de la constancia
    };

    calcularEdad();
  }, [selectedDate]);

  function CustomDatePickerNacimiento(props) {
    const today = dayjs();
    const [invalidFormat, setInvalidFormat] = React.useState(false);
    const [cleared, setCleared] = React.useState(false);

    React.useEffect(() => {
      if (cleared) {
        setSelectedDate(null);
        const timeout = setTimeout(() => {
          setCleared(false);
        }, 1500);

        return () => clearTimeout(timeout);
      }
      return () => {};
    }, [cleared]);

    const handleDateChange = (date) => {
      if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
        setInvalidFormat(true);
      } else {
        setInvalidFormat(false);
        setSelectedDate(date);
        setFechaVacia(false);
      }
    };

    const handleKeyDown = (event) => {
      event.preventDefault(); // Evitar la entrada manual
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoItem>
          <DatePicker
            readOnly
            format={"DD/MM/YYYY"}
            value={selectedDate}
            views={["year", "month", "day"]}
            onAccept={handleDateChange}
            slotProps={{
              field: {
                clearable: true,
                onClear: () => setCleared(true),
                InputProps: {
                  readOnly: true, // Hacer el campo solo lectura
                },
              },
              textField: {
                variant: "filled", // Cambiar la variante a 'filled'
                helperText: fechaVacia
                  ? "Seleccione la fecha de nacimiento"
                  : invalidFormat
                  ? "Formato de fecha incorrecto"
                  : selectedDate && dayjs(selectedDate).isAfter(today)
                  ? "La fecha seleccionada es mayor a la fecha actual"
                  : null,
                error: fechaVacia || invalidFormat,
                onKeyDown: handleKeyDown,
              },
            }}
            maxDate={today}
            {...props}
          />
        </DemoItem>
        {cleared && (
          <Alert
            sx={{ position: "absolute", bottom: 0, right: 0 }}
            severity="success"
          >
            Fecha Borrada!
          </Alert>
        )}
      </LocalizationProvider>
    );
  }

  useEffect(() => {
    const sessionData = JSON.parse(localStorage.getItem("sessionData"));

    if (sessionData) {
      sessi.sessionData = sessionData; // Restaurar datos de sesión
    }

    setEstadoParticipante(sessi.sessionData.estado); // Setear el estado del participante

    async function fetchData() {
      setLoading(true);
      try {
        const dni = sessi.sessionData.identidad;
        const queryString = `dni=${dni}`;
        const signature = CryptoJS.HmacSHA256(queryString, useFront).toString(
          CryptoJS.enc.Hex
        );
        const formData = new FormData();
        formData.append("dni", dni);

        const response = await fetch(`${dominio}/api/datos/`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Signature": signature,
          },
        });

        const data = await response.json();
        if (data && data.informacion) {
          const info = data.informacion.reduce((acc, item) => {
            const [key, value] = item.split(": ");
            acc[key.trim()] = value ? value.trim() : "";
            return acc;
          }, {});

          setFormData({
            nombres: `${info.Nombre1 || ""} ${info.Nombre2 || ""}`,
            apellidos: `${info.Apellido1 || ""} ${info.Apellido2 || ""}`,
            fechaNacimiento: dayjs(
              info.FechaNacimiento,
              "DD/MM/YYYY HH:mm:ss a"
            ),
          });
          setSelectedDate(dayjs(info.FechaNacimiento, "DD/MM/YYYY HH:mm:ss a"));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  // Guarda sessi.sessionData en el localStorage para persistencia
  useEffect(() => {
    if (sessi.sessionData) {
      localStorage.setItem("sessionData", JSON.stringify(sessi.sessionData));
    }
  }, [sessi.sessionData]);

  const [formData, setFormData] = useState({
    nombres: "",
    apellidos: "",
    fechaNacimiento: null,
  });

  const handleValidarCampos = () => {
    let errores = [];

    if (
      !sessi.sessionData.identidad ||
      sessi.sessionData.identidad.trim() === ""
    ) {
      errores.push("El campo 'Número de Identidad' es obligatorio.");
    }

    if (!telefono) {
      errores.push("-El campo 'Teléfono' es obligatorio.");
    } else if (telefono.length !== 8) {
      errores.push("-El teléfono debe tener 8 dígitos.");
    }

    if (!selectedIdentidadSoli) {
      errores.push("-Debe adjuntar la copia de la identidad en formato PDF.");
    }

    if (!comentarioSolicitud) {
      errores.push("-Debe detallar la solicitud de la constancia.");
    }
    if (!selectedConstancia) {
      errores.push(
        "-Debe adjuntar la constancia o certificación de no haber encontrado expediente o documentación en la institución que laboró."
      );
    }
    if (precioCons > 0) {
      if (aceptoPago === false) {
        errores.push(
          "-Debe aceptar las condiciones de pago antes de solicitar la constancia."
        );
      }
    }

    if (aceptoDoc === false) {
      errores.push(
        "-Debe aceptar las condiciones de documentación antes de solicitar la constancia."
      );
    }

    if (errores.length > 0) {
      setErrorMessage(
        <ul>
          {errores.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      );
      setOpenErrorDialog(true);
      return false;
    }
    return true;
  };

  const handleCloseErrorDialog = () => {
    setOpenErrorDialog(false);
  };

  const handleOpenDialog = () => {
    setOpenConfirm(true);
  };

  const handleCloseDialog = () => {
    setOpenConfirm(false);
  };

  const handleConfirmar = () => {
    setOpenConfirm(false);
    handleSolicitarConstancia();
  };

  const handleDragOverIdentidadSoli = (event) => {
    event.preventDefault();
  };

  const handleDragOverConstancia = (event) => {
    event.preventDefault();
  };

  const handleDropIdentidadSoli = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedIdentidadSoli(file);
    } else {
      alert("Por favor suelta un archivo con formato PDF.");
    }
  };

  const handleDropConstancia = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedConstancia(file);
    } else {
      alert("Por favor suelta un archivo con formato PDF.");
    }
  };

  const handleClickIdentidadSoli = () => {
    document.getElementById("selectedIdentidadSoli").click();
  };

  const handleClickConstancia = () => {
    document.getElementById("selectedConstancia").click();
  };

  const handleFileChangeIdentidadSoli = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedIdentidadSoli(file);
    } else {
      alert("Por favor seleccione un archivo con formato PDF.");
    }
  };

  const handleFileChangeConstancia = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedConstancia(file);
    } else {
      alert("Por favor seleccione un archivo con formato PDF.");
    }
  };

  return (
    <div id="my-container">
      <Container style={{ marginTop: isMobile ? 1 : 50 }}>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <h1>SOLICITUD DE CONSTANCIA RAZONADA</h1>
          </Grid>
        </Grid>
        <Divider style={{ marginTop: 20 }} />

        <Box marginTop={2}>
          <Stack direction="row">
            <h3>I. DATOS DEL SOLICITANTE</h3>
          </Stack>
          <Stack direction={isMobile ? "column" : "row"} mt={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <TextField
                    id="NumeroIdentidad"
                    label="Número de Identidad"
                    variant="filled"
                    value={sessi.sessionData.identidad}
                    inputProps={{ maxLength: 13 }} // Limitar la longitud máxima a 13 caracteres
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <TextField
                    id="Nombres"
                    label="Nombres"
                    variant="filled"
                    value={formData.nombres}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <TextField
                    id="Apellidos"
                    label="Apellidos"
                    variant="filled"
                    value={formData.apellidos}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <CustomDatePickerNacimiento
                    id="FechaNacimiento"
                    label="Fecha Nacimiento"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <TextField
                    id="Edad"
                    label="Edad"
                    value={`${edad} años`}
                    variant="filled"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <TextField
                    id="Telefono"
                    label="Teléfono"
                    variant="outlined"
                    value={telefono}
                    onChange={(e) => {
                      const valorSoloNumeros = e.target.value.replace(
                        /\D/g,
                        ""
                      );
                      if (valorSoloNumeros.length <= 8)
                        setTelefono(valorSoloNumeros);
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      maxLength: 8,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneIcon sx={{ color: "action.active" }} />
                          <Typography
                            variant="body2"
                            sx={{ mr: 0.5, color: "text.secondary" }}
                          >
                            (+504)
                          </Typography>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Stack>

          <Divider style={{ marginTop: 5 }} />

          <Box marginTop={5}>
            <h3>II. COPIA DE LA IDENTIDAD DEL SOLICITANTE EN FORMATO PDF</h3>
            <Typography style={{ textAlign: "justify" }}>
              Copia de la tarjeta de identidad por ambos lados en un solo
              documento PDF.
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              onDragOver={handleDragOverIdentidadSoli}
              onDrop={handleDropIdentidadSoli}
              marginTop={2}
            >
              <Box
                style={{
                  padding: "50px",
                  width: isMobile ? "300px" : "700px",
                  textAlign: "center",
                  borderColor: selectedIdentidadSoli ? "green" : "#a0a0a0",
                  borderRadius: 5,
                  borderWidth: 5,
                  borderStyle: "dashed",
                }}
              >
                <Tooltip
                  title={
                    <div style={{ textAlign: "center" }}>
                      <p style={{ fontSize: 15, textAlign: "justify" }}>
                        El archivo pdf debe contener la tarjeta de identidad por
                        ambos lados de la siguiente forma:
                      </p>
                      <img
                        src={IdentidadEjemplo}
                        alt="Identidad Ejemplo"
                        style={{ width: "200px", height: "auto" }}
                      />
                    </div>
                  }
                  interactive="true" // Cambiado a cadena en lugar de valor booleano
                >
                  <CloudUploadIcon style={{ fontSize: 48, color: "gray" }} />
                </Tooltip>
                <br />
                <Button
                  variant="contained"
                  onClick={handleClickIdentidadSoli}
                  style={{ marginTop: "10px", backgroundColor: "#ECECEC" }}
                >
                  Seleccionar Identidad En PDF
                </Button>
                <input
                  id="selectedIdentidadSoli"
                  type="file"
                  accept=".pdf"
                  style={{ display: "none" }}
                  onChange={handleFileChangeIdentidadSoli}
                />
                {!selectedIdentidadSoli && (
                  <p>
                    Seleccione el archivo PDF o Arrástrelo dentro del contenedor
                  </p>
                )}
                {selectedIdentidadSoli && (
                  <p>Archivo seleccionado: {selectedIdentidadSoli.name}</p>
                )}
              </Box>
            </Box>
          </Box>
          <Divider style={{ marginTop: 5 }} />

          <Box marginTop={5}>
            <h3 style={{ textAlign: "justify" }}>
              III. CONSTANCIA O CERTIFICACIÓN DE NO HABER ENCONTRADO EXPEDIENTE
              O DOCUMENTACIÓN EN LA INSTITUCIÓN EN LA QUE LABORÓ EN FORMATO PDF
            </h3>
            <Typography style={{ textAlign: "justify" }}>
              Constancia emitida por la dependencia donde laboro el
              participante, en la cual se indiquen los motivos por los cuales no
              se encontró documentación del participante (como acuerdos de
              nombramiento y cancelación). En caso de que la dependencia ya no
              esté activa, deberá solicitar dicha constancia a la Secretaría de
              Finanzas, o bien, a la Comisión Técnica Liquidadora
              correspondiente, quienes deberán explicar detalladamente la
              situación.
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              onDragOver={handleDragOverConstancia}
              onDrop={handleDropConstancia}
              marginTop={2}
            >
              <Box
                style={{
                  padding: "50px",
                  width: isMobile ? "300px" : "700px",
                  textAlign: "center",
                  borderColor: selectedConstancia ? "green" : "#a0a0a0",
                  borderRadius: 5,
                  borderWidth: 5,
                  borderStyle: "dashed",
                }}
              >
                <CloudUploadIcon style={{ fontSize: 48, color: "gray" }} />
                <br />
                <Button
                  variant="contained"
                  onClick={handleClickConstancia}
                  style={{ marginTop: "10px", backgroundColor: "#ECECEC" }}
                >
                  Seleccionar Constancia En PDF
                </Button>
                <input
                  id="selectedConstancia"
                  type="file"
                  accept=".pdf"
                  style={{ display: "none" }}
                  onChange={handleFileChangeConstancia}
                />
                {!selectedConstancia && (
                  <p>
                    Seleccione el archivo PDF o Arrástrelo dentro del contenedor
                  </p>
                )}
                {selectedConstancia && (
                  <p>Archivo seleccionado: {selectedConstancia.name}</p>
                )}
              </Box>
            </Box>
          </Box>
          <Divider style={{ marginTop: 5 }} />

          <Stack
            direction="column" // Siempre en columna
            alignItems="flex-start" // Alinea los elementos al inicio del contenedor
            spacing={2} // Espaciado entre los elementos
            marginTop={3}
          >
            <h3 style={{ textAlign: "justify" }}>
              Detalle sobre su solicitud:
            </h3>
            <Typography style={{ textAlign: "justify" }}>
              Por favor, indique <strong>los años específicos</strong> para los
              cuales requiere que se extienda la constancia.
              <br></br>
              <br></br>
              Ejemplo: "2018, 2019, 2020" o "Enero 2020 - Diciembre 2022"
              <br></br>
              <br></br>
              Asegúrese de que la documentación adjunta corresponda a los
              períodos solicitados; de lo contrario, no será posible procesar su
              solicitud.
            </Typography>
            <FormControl sx={{ m: 1, width: "100%" }}>
              <TextField
                label="Ingrese su comentario aquí"
                id="ComentarioParticipante"
                multiline
                rows={4}
                variant="outlined"
                value={comentarioSolicitud}
                onChange={(e) => setComentarioSolicitud(e.target.value)}
              />
            </FormControl>
          </Stack>
        </Box>
        <Divider style={{ marginTop: 5 }} />

        {/* Sección de instrucciones */}
        <Box marginTop={4} padding={3} bgcolor="#f5f5f5" borderRadius={2}>
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            fontWeight={"bold"}
          >
            INSTRUCCIONES PARA SOLICITAR CONSTANCIA
          </Typography>

          <ol style={{ paddingLeft: 16 }}>
            <li style={{ textAlign: "justify" }}>
              Presione sobre el botón “Solicitar Constancia”, esto generará un
              número de solicitud, y será redirigido a la pantalla de Historial
              de Solicitud de Constancias. El número de solicitud generado se
              encontrará en estado <strong>Revisión</strong>. Uno de nuestros
              oficiales verificará la documentación presentada. En caso de que
              la solicitud no cumpla con los requisitos establecidos, ésta podrá
              ser <strong>rechazada</strong> o bien recibirá una notificación
              por correo electrónico solicitando la <strong>subsanación</strong>{" "}
              de los documentos, la cual podrá realizar a través de la opción{" "}
              <strong>“Mis Solicitudes”</strong>.
            </li>
            {precioCons > 0 && (
              <>
                <li style={{ textAlign: "justify" }}>
                  Al finalizar el proceso de revisión el estado de la solicitud
                  pasará a <strong>“Pendiente de Pago”</strong> y recibirá
                  notificación por correo electrónico para efectuar el pago de
                  L.
                  {precioCons}, el cual podrá realizar en{" "}
                  <strong>Banco Atlántida</strong> a través de los siguientes
                  canales: ventanilla, banca en línea para personas o banca en
                  línea para empresas.{" "}
                  <strong>
                    Si el pago no es efectuado en un plazo de 72 horas el
                    sistema anulará la solicitud.{" "}
                  </strong>
                </li>
                <li style={{ textAlign: "justify" }}>
                  Una vez realizado el pago, el estado de su solicitud cambiará
                  a <strong>“Pendiente de Emitir”</strong>. Posteriormente, uno
                  de nuestros oficiales procesará la solicitud y, al emitir la
                  constancia, el estado de la solicitud pasará a{" "}
                  <strong>“Emitida”</strong>. Su constancia estará disponible
                  para descarga en la opción <strong>“Mis Solicitudes”</strong>{" "}
                  y también será enviada automáticamente a su correo
                  electrónico.
                </li>
              </>
            )}
            {precioCons == 0 && (
              <>
                <li style={{ textAlign: "justify" }}>
                  Una vez realizado la Revisión, el estado de su solicitud
                  cambiará a <strong>“Pendiente de Emitir”</strong>.
                  Posteriormente, uno de nuestros oficiales procesará la
                  solicitud y, al emitir la constancia, el estado de la
                  solicitud pasará a <strong>“Emitida”</strong>. Su constancia
                  estará disponible para descarga en la opción{" "}
                  <strong>“Mis Solicitudes”</strong> y también será enviada
                  automáticamente a su correo electrónico.
                </li>
              </>
            )}

            <Typography
              variant="body1"
              fontWeight={"bold"}
              style={{ marginTop: 16 }}
            >
              Acepte las siguientes condiciones antes de solicitar la
              constancia:
            </Typography>

            {precioCons > 0 && (
              <Box
                component="li"
                display="flex"
                alignItems="center"
                style={{ textAlign: "justify", marginTop: 8 }}
              >
                <Checkbox
                  edge="start"
                  checked={aceptoPago}
                  onChange={(e) => setAceptoPago(e.target.checked)}
                />
                <Typography variant="body1">
                  Acepto que una vez realizado el pago de la solicitud, no se
                  hará reembolso del mismo, aún si la constancia no pudiera
                  emitirse por incumplimiento de los requisitos.
                </Typography>
              </Box>
            )}
            {/* Ítem 5: aceptación con checkbox */}
            <Box
              component="li"
              display="flex"
              alignItems="center"
              style={{ textAlign: "justify", marginTop: 8 }}
            >
              <Checkbox
                edge="start"
                checked={aceptoDoc}
                onChange={(e) => setAceptoDoc(e.target.checked)}
              />
              <Typography variant="body1">
                Me aseguré de adjuntar toda la documentación solicitada de
                manera legible y completa, ya que las solicitudes incompletas no
                serán procesadas.
              </Typography>
            </Box>
          </ol>

          <Typography
            variant="body2"
            sx={{ marginTop: 2, fontStyle: "italic", textAlign: "justify" }}
          >
            En caso de necesitar soporte técnico, contacte a nuestro Call Center
            al 2290-1900
          </Typography>
        </Box>

        {/* Botón para descargar la constancia */}
        <Grid container justifyContent="center" style={{ marginTop: 20 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (handleValidarCampos()) {
                handleOpenDialog();
              }
            }}
            disabled={loading}
            style={{ position: "relative" }}
          >
            Solicitar Constancia
            {loading && (
              <CircularProgress
                size={24}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -12,
                  marginLeft: -12,
                }}
              />
            )}
          </Button>
        </Grid>

        <Dialog open={openConfirm} onClose={handleCloseDialog}>
          <DialogTitle textAlign={"center"}>Confirmación</DialogTitle>
          <DialogContent>
            <Typography variant="body1" textAlign={"justify"}>
              Al hacer clic en 'SÍ', confirma que ha verificado que toda la
              documentación solicitada está completa, legible y debidamente
              adjunta.{" "}
              {precioCons > 0 && (
                <>
                  <strong>Advertencia:</strong> Las solicitudes incompletas no
                  se procesarán y{" "}
                  <strong>
                    el pago no es reembolsable (en caso de que aplique),
                  </strong>{" "}
                  incluso si la constancia no puede emitirse por incumplimiento
                  de requisitos.
                </>
              )}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="error">
              NO
            </Button>
            <Button
              onClick={handleConfirmar}
              color="primary"
              autoFocus
              variant="contained"
            >
              SI
            </Button>
          </DialogActions>
        </Dialog>

        {/* Diálogo de instrucciones después de generar la solicitud */}
        <Dialog
          open={openInstructions}
          onClose={handleCloseInstructions}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <Box display="flex" justifyContent="center" alignItems="center">
              Solicitud Generada Exitosamente
              <CheckCircleIcon color="success" sx={{ ml: 1 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              textAlign={"justify"}
            >
              <strong>Número de solicitud:</strong> {numeroSolicitud}
              <br />
              <br />
              <strong>1. </strong> Su solicitud ha sido generada y se encuentra
              en estado de <strong>“Revisión”</strong>. Uno de nuestros
              oficiales verificará la documentación presentada. En caso de que
              la solicitud no cumpla con los requisitos establecidos, ésta podrá
              ser <strong>rechazada</strong> o bien recibirá una notificación
              por correo electrónico solicitando la <strong>subsanación</strong>{" "}
              de los documentos, la cual podrá realizar a través de la opción{" "}
              <strong>“Mis Solicitudes”</strong>.<br />
              <br />
              {precioCons > 0 && (
                <>
                  <strong>2. </strong> Al finalizar el proceso de revisión el
                  estado de la solicitud pasará a{" "}
                  <strong>“Pendiente de pago”</strong> y recibirá notificación
                  por correo electrónico para efectuar el pago de L.{" "}
                  <strong>
                    {montoConstancia !== null
                      ? `L.${parseFloat(montoConstancia).toFixed(2)}`
                      : ""}
                  </strong>{" "}
                  , el cual podrá realizar en <strong>Banco Atlántida</strong> a
                  través de los siguientes canales: ventanilla, banca en línea
                  para personas o banca en línea para empresas.{" "}
                  <strong>
                    Si el pago no es efectuado en un plazo de 72 horas el
                    sistema anulará la solicitud.{" "}
                  </strong>
                  <br />
                  <br />
                  <strong>3. </strong> Una vez realizado el pago, el estado de
                  su solicitud cambiará a <strong>“Pendiente de Emitir”</strong>
                  . Posteriormente, uno de nuestros oficiales procesará la
                  solicitud y, al emitir la constancia, el estado de la
                  solicitud pasará a <strong>“Emitida”</strong>. Su constancia
                  estará disponible para descarga en la opción{" "}
                  <strong>“Mis Solicitudes”</strong> y también será enviada
                  automáticamente a su correo electrónico.
                </>
              )}
              {precioCons == 0 && (
                <>
                  <strong>2. </strong> Una vez realizado la Revisión, el estado
                  de su solicitud cambiará a{" "}
                  <strong>“Pendiente de Emitir”</strong>. Posteriormente, uno de
                  nuestros oficiales procesará la solicitud y, al emitir la
                  constancia, el estado de la solicitud pasará a{" "}
                  <strong>“Emitida”</strong>. Su constancia estará disponible
                  para descarga en la opción <strong>“Mis Solicitudes”</strong>{" "}
                  y también será enviada automáticamente a su correo
                  electrónico.
                </>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleCloseInstructions}
              color="primary"
              autoFocus
              variant="contained"
            >
              Entendido
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openErrorDialog} onClose={handleCloseErrorDialog}>
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <WarningIcon color="error" sx={{ fontSize: 30, marginRight: 1 }} />
            {"Aviso"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText component="div" textAlign={"justify"}>
              {errorMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleCloseErrorDialog}
              color="primary"
              variant="contained"
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
          <DialogTitle sx={{ textAlign: "center" }}>
            Requisitos para solicitar Constancia Razonada
          </DialogTitle>

          <DialogContent dividers>
            <Box
              component="img"
              src={requisitos}
              alt="Requisitos para solicitar constancia razonada"
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
                mx: "auto",
              }}
            />
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleClose}
              color="primary" // Botón en rojo
              variant="contained"
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </div>
  );
}

export default ConstanciaRazonadaScreen;
